module.exports = __webpack_public_path__ + "static/media/DSCF9764.794c5a83.jpg";